import axios from "axios";
const KEY = "sp_support22";
const API = process.env.REACT_APP_API_BASE_URL.replace(/\/$/, "");
let context = null;
const supportStore = {
  getItem: (key) => window.sessionStorage.getItem("sp_view_" + key),
  setItem: (key, value) => window.sessionStorage.setItem("sp_view_" + key, String(value)),
  removeItem: (key) => window.sessionStorage.removeItem("sp_view_" + key),
  clear: () => Object.keys(window.sessionStorage).filter(k => k.startsWith("sp_view_")).forEach(k => window.sessionStorage.removeItem(k)),
};
export function supportContext() { return context; }
export function supportRequest(action, data) {
  return axios.post(API + "?status=1&f=" + encodeURIComponent(action), data, {headers:{"X-SP-Support":context.token}, timeout:20000});
}
export async function endSupport(returnToProfile) {
  const previous = context;
  if (previous) {
    try { await supportRequest("supportEnd"); } catch (_) {}
  }
  window.sessionStorage.removeItem(KEY);
  supportStore.clear();
  if (returnToProfile && previous) window.location.replace("https://www.backend.salsaworldstandardclass.com/de/student-info/" + previous.student_id);
}
export async function bootSupport() {
  const entry = window.location.pathname === "/support";
  if (!entry && !window.sessionStorage.getItem(KEY)) return false;
  const grant = entry ? new URLSearchParams(window.location.hash.slice(1)).get("grant") : null;
  if (entry && grant) {
    window.history.replaceState(null, "", "/support");
    if (!/^[a-f0-9]{64}$/.test(grant || "")) throw new Error("Bitte den Prüfzugang über das Schülerprofil öffnen.");
    const body = new FormData(); body.append("grant", grant);
    const response = await axios.post(API + "?status=1&f=supportRedeem", body, {timeout:20000});
    if (!response.data || response.data.status !== true) throw new Error("Prüfzugang ungültig oder abgelaufen. Bitte erneut im Schülerprofil öffnen.");
    context = response.data;
    window.sessionStorage.setItem(KEY, JSON.stringify(context));
  } else context = JSON.parse(window.sessionStorage.getItem(KEY));
  if (!context || !/^[a-f0-9]{64}$/.test(context.token || "") || Date.now() >= context.expires_at*1000) throw new Error("Prüfzugang abgelaufen. Bitte erneut im Schülerprofil öffnen.");
  // This tab alone uses support storage. The real App's localStorage is untouched.
  Object.defineProperty(window, "localStorage", {configurable:true, get:() => supportStore});
  supportStore.clear();
  Object.entries({session_user_id:context.student_id, session_school_id:context.school_id,
    session_user_type:"student", session_school_login_type:"student_login", session_language:"de",
    session_user_login_cookie:"", session_user_firstname:context.name}).forEach(([k,v]) => supportStore.setItem(k,v));
  axios.interceptors.request.use(config => {
    const url = new URL(config.url, window.location.origin);
    if (url.origin !== new URL(API).origin) return Promise.reject(new Error("Nur die Prüf-API ist im Prüfmodus verfügbar."));
    url.searchParams.delete("login_cookie");
    config.url = url.toString();
    config.headers["X-SP-Support"] = context.token;
    return config;
  });
  axios.interceptors.response.use(response => response, error => {
    if (error.response && [401,403].includes(error.response.status) && error.response.data?.code === "support_expired") window.dispatchEvent(new Event("sp-support-expired"));
    return Promise.reject(error);
  });
  return true;
}
